import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EducationEmployee } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class EducationEmployeeService extends InfrastructureService<EducationEmployee> {
  protected readonly endpoint: string = '/EducationEmployees';

  constructor(protected http: HttpClient) {
    super(http);
  }
}
